import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';

const ChildrenBlur = ({ children, onBlur, ...props }) => {
  const handleBlur = useCallback(
    (e) => {
      const currentTarget = e.currentTarget;

      // Give browser time to focus the next element
      requestAnimationFrame(() => {
        // Check if the new focused element is a child of the original container
        if (!currentTarget.contains(document.activeElement)) {
          onBlur();
        }
      });
    },
    [onBlur],
  );

  return (
    <span {...props} onBlur={handleBlur}>
      {children}
    </span>
  );
};

ChildrenBlur.propTypes = {
  children: PropTypes.node,
  onBlur: PropTypes.func,
};

export default (Component) => {
  return (props) => {
    const [hasFocus, setFocus] = useState(false);

    return (
      <ChildrenBlur
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}>
        <Component {...props} _hasFocus={hasFocus} />
      </ChildrenBlur>
    );
  };
};
